import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Treatments.css";
import logo from '../images/6_Ayur copy.webp'
import serviceImg from "../images/main_kalpa.webp";
import { FaPhone } from "react-icons/fa6";
import { FaLocationDot } from "react-icons/fa6";
import AyurvedaFooter from "../AyurvedaFooter/AyurvedaFooter";
import ScrollToTop from '../ScrollToTop'
import { MdCall } from "react-icons/md";
import { Link, NavLink, useLocation } from "react-router-dom";
import WhatsAppButton from "../WhatsAppButton";
import { FaLocationArrow } from "react-icons/fa6";
import ScrollTop from "../ScrollTop";
import { MdOutlineMail } from "react-icons/md";
import { Helmet } from 'react-helmet-async';

export default function Soundarya() {
  const location = useLocation();

  const isTreatmentActive =
    location.pathname.startsWith("/treatment") ||
    location.pathname.startsWith("/postnatal") ||
    location.pathname.startsWith("/rejuvenation") ||
    location.pathname.startsWith("/hair_treatment") ||
    location.pathname.startsWith("/lifestyle_yoga") ||
    location.pathname.startsWith("/soundarya_kalpa");
  return (
    <>
    <Helmet>
  <title>
    Soundarya Kalpa Treatment in Kerala
  </title>

  <meta
    name="description"
    content="Experience Soundarya Kalpa at Ayurmoksha Ayurveda clinic in Kozhikode, Kerala. Our authentic Ayurvedic beauty therapies enhance natural skin and hair health, promote inner radiance, and restore balance through traditional herbal treatments and personalized care."
  />

  <meta
    name="keywords"
    content="Soundarya Kalpa treatment Kozhikode Kerala, Ayurvedic Beauty Therapy Kerala, Ayurvedic Skin Treatment Kozhikode, Natural Beauty Ayurveda Kerala, Herbal Beauty Treatments Kerala, Ayurmoksha Soundarya Kalpa, Traditional Ayurvedic Beauty Care"
  />

  <meta name="robots" content="index, follow" />

  <link rel="canonical" href="https://ayurmoksha.in/soundarya_kalpa" />

  {/* Open Graph Meta */}
  <meta property="og:locale" content="en_IN" />
  <meta property="og:type" content="website" />
  <meta
    property="og:title"
    content="Soundarya Kalpa | Ayurvedic Beauty Therapy in Kozhikode Kerala"
  />
  <meta
    property="og:description"
    content="Ayurmoksha Ayurveda clinic in Kozhikode Kerala offers Soundarya Kalpa – traditional Ayurvedic beauty therapies for healthy skin, radiant complexion, and natural rejuvenation."
  />
  <meta
    property="og:url"
    content="https://ayurmoksha.in/soundarya_kalpa"
  />
  <meta
    property="og:site_name"
    content="Ayurmoksha Ayurveda clinic"
  />
  <meta
    property="og:image"
    content="https://ayurmoksha.in/logo.webp"
  />
  <meta
    property="og:image:alt"
    content="Soundarya Kalpa Ayurvedic Beauty Therapy at Ayurmoksha Ayurveda clinic Kozhikode"
  />

  <meta name="author" content="Ayurmoksha Ayurveda clinic" />
</Helmet>

    <ScrollTop/>
     {/* main section */}
      <section className="container-fluid about-main-section">
      {/* Overlay */}
      <div className="about-main-overlay"></div>

      {/* Navbar */}
        <nav className="navbar navbar-expand-lg navbar-dark about-navbar">
        <div className="container">

          {/* Logo */}
           <Link className="navbar-brand" to="#"><span><img src={logo} alt="logo" className="brand-logo bg_new"/><span  className=" logo_txt mt-5" ></span></span>
          </Link>

          {/* Toggle */}
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#aboutNavbar"
            aria-controls="aboutNavbar"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* Menu */}
          <div className="collapse navbar-collapse justify-content-center" id="aboutNavbar">

             <ul className="navbar-nav align-items-lg-center gap-lg-3 text-center">
              <li className="nav-item">
                <NavLink className="nav-link" to="/" style={({ isActive }) => ({ color: isActive ? "green" : "white" })}><b>Home</b></NavLink>
              </li>

              <li className="nav-item">
              
                <NavLink  className="nav_Active" to="/ourstory" style={({ isActive }) => ({ color: isActive ? "green" : "white" })}><b>Our Story</b></NavLink>
              </li>

            <li className="nav-item dropdown">
  <NavLink
    to="/treatment"
    className="nav-link dropdown-toggle"
    data-bs-toggle="dropdown"
    style={() => ({
      color: isTreatmentActive ? "orange" : "white"
    })}
  >
    <b>Treatments</b>
  </NavLink>

  <ul className="dropdown-menu">
    <li>
      <NavLink
        to="/treatment"
        className="dropdown-item"
        style={({ isActive }) => ({
          color: isActive ? "green" : "black"
        })}
      >
        All Treatments
      </NavLink>
    </li>

    <li>
      <NavLink
        to="/postnatal"
        className="dropdown-item"
        style={({ isActive }) => ({
          color: isActive ? "green" : "black"
        })}
      >
        Postnatal Care
      </NavLink>
    </li>

    <li>
      <NavLink
        to="/rejuvenation"
        className="dropdown-item"
        style={({ isActive }) => ({
          color: isActive ? "green" : "black"
        })}
      >
        Rejuvenation Therapy
      </NavLink>
    </li>

    <li>
      <NavLink
        to="/hair_treatment"
        className="dropdown-item"
        style={({ isActive }) => ({
          color: isActive ? "green" : "black"
        })}
      >
        Hair Treatment
      </NavLink>
    </li>

    <li>
      <NavLink
        to="/lifestyle_yoga"
        className="dropdown-item"
        style={({ isActive }) => ({
          color: isActive ? "green" : "black"
        })}
      >
        Life Style Guidance & Yoga
      </NavLink>
    </li>

    <li>
      <NavLink
        to="/soundarya_kalpa"
        className="dropdown-item"
        style={({ isActive }) => ({
          color: isActive ? "green" : "black"
        })}
      >
        Soundarya Kalpa
      </NavLink>
    </li>
  </ul>
</li>

                <li className="nav-item">
                  <NavLink className="nav_Active" to="/contact" style={({ isActive }) => ({ color: isActive ? "green" : "white" })}><b>contact</b></NavLink>
              </li>
             
            </ul>
          </div>

        </div>
        <div className="d-none d-lg-flex align-items-center gap-3 ms-auto">
<span className="phone-inline">
  <MdCall /> <b>+91 7736 111 482</b>
</span>


  <a
    href="https://wa.me/917736111482?text=Hello%20I%20would%20like%20to%20know%20more%20about%20your%20treatments"
    target="_blank"
    rel="noopener noreferrer"
    className="messenger-btn"
    style={{ backgroundColor: "#006400", textDecoration: "none" }}
  >
    WhatsApp
  </a>
</div>

      </nav>

      {/* Center Content */}
      <div className="about-main-content">
        <h1 className="head-font" style={{color:'#f7f0d3'}}>Soundarya Kalpa</h1>
        <p>
          <span className="para-font">Home</span>
          <span className="mx-2">»</span>
          <span className="para-font">Soundarya Kalpa</span>
        </p>
      </div>
    </section>
    {/* =========== */}
    <section className="service-detail-wrapper">
      <div className="container">
        <div className="row">

          {/* LEFT CONTENT */}
          <div className="col-lg-8 mb-5 mb-lg-0">
            <div className="service-image">
              <img src={serviceImg} alt="Abhyanga Therapy"  style={{height:'500px'}}/>
            </div>

            <h2 className="service-title head-font">Soundarya Kalpa</h2>

            <p className="service-desc para-font justify-text">
             Soundarya Kalpa is a classical Ayurvedic beauty and skin rejuvenation therapy focused on enhancing skin health, natural radiance, and facial harmony through time-tested traditional practices. According to Ayurveda, true beauty is a reflection of balanced doshas, efficient digestion, mental calmness, and purified internal channels.<br/><br/>
Moving beyond superficial cosmetic correction, this therapy works at a deeper level cleansing, nourishing, and revitalizing the skin from within, thereby restoring lasting glow, vitality, and youthful balance.

            </p>

            <h5 className="service-subtitle head-font">How beneficial is Soundarya Kalpa  </h5> 

            <div className="row service-benefits">
              <div className="col-md-6">
                <ul className="para-font benefit-list">
                  <li>
                    <span className="tick">✔</span>
             <span className="text">Enhances natural skin glow and overall radiance</span></li>
                  <li><span className="tick">✔</span>
    <span className="text">Improves skin texture, tone, and brightness</span></li>
                  <li><span className="tick">✔</span>
    <span className="text">Supports anti-ageing by improving skin firmness and elasticity</span></li>
                </ul>
              </div>
              <div className="col-md-6">
                <ul className="para-font benefit-list">
                  <li><span className="tick">✔</span>
    <span className="text">Detoxifies the skin by purifying internal body channels</span></li>
                  <li><span className="tick">✔</span>
    <span className="text">Restores dosha balance for sustained skin health</span></li>
                  <li><span className="tick">✔</span>
    <span className="text">Keep   Herbal Cleansing</span></li>
                </ul>
              </div>
            </div>
          </div>

          {/* RIGHT SIDEBAR */}
          <div className="col-lg-4">
            <div className="service-sidebar">

              <div className="sidebar-card">
                 <h5 className="head-font" style={{color:'wheat'}}>Our Services</h5>
                 <ul className="para-font">
                  <li><FaLocationArrow />&nbsp;&nbsp;Postnatal Care</li>
                  <li><FaLocationArrow />&nbsp;&nbsp;Rejuvenation Therapy</li>
                  <li><FaLocationArrow />&nbsp;&nbsp;Hair Treatments</li>
                  <li><FaLocationArrow />&nbsp;&nbsp;Life Style Guidance & Yoga</li>
                  <li><FaLocationArrow />&nbsp;&nbsp;Soundarya Kapla</li>
                </ul>
              </div>

              <div className="sidebar-card">
                <h5 className="head-font" style={{color:'wheat'}}>Treatments overview </h5>
                 <ul className="para-font">
                  <li><FaLocationArrow />&nbsp;&nbsp;Mukha Abhyangam</li>
                  <li><FaLocationArrow />&nbsp;&nbsp;Mukha Lepam</li>
                  <li><FaLocationArrow />&nbsp;&nbsp;Mukha Rasayana Therapies</li>
                  <li><FaLocationArrow />&nbsp;&nbsp;Internal Ayurvedic Support</li>
                  <li><FaLocationArrow />&nbsp;&nbsp;Herbal Steam Therapy</li>
                   <li><FaLocationArrow />&nbsp;&nbsp;Herbal Cleansing </li>
                    <li><FaLocationArrow />&nbsp;&nbsp;Herbal Scrubbing </li>
                     <li><FaLocationArrow />&nbsp;&nbsp;Nasyam</li>
                </ul>
              </div>

              <div className="sidebar-card">
                <h5 className="head-font" style={{color:'wheat'}}>Our Contact</h5>
               <ul className="para-font">
                  <li><FaPhone/> +91 7736 111 482</li>
                  <li><MdOutlineMail/> ayurmokshacalicut@gmail.com</li>
                  <li><FaLocationDot/>&nbsp;Ruby Road, Karuvanthuruthy, Feroke, &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Kozhikode,Kerala 673631</li>
                </ul>
              </div>

            </div>
          </div>

        </div>
      </div>
    </section>
    <AyurvedaFooter/>
       <ScrollToTop/>
        <WhatsAppButton />

    </>
  );
}
